/**
 * Check win results hook for tickets.
 */
import { useState, useCallback } from 'react';
import ENDPOINTS from 'shared/api/endpoints';
import RequestClient from 'shared/api/http-client';
import RequestSource from 'shared/api/request-tokens';
import { useUserSessionContext } from 'features/session/userSessionStore';

export interface UseCheckWinResultsReturn {
  win_results: Record<string, unknown>;
  error: unknown;
  loading: boolean;
  setWinResult: React.Dispatch<React.SetStateAction<Record<string, unknown>>>;
  checkWinResults: (params: { event_id: string | number }) => Promise<void>;
}

/**
 * Check for ticket win result. No-op when not logged in (guest or no session).
 */
export function useCheckWinResults(): UseCheckWinResultsReturn {
  const [{ user }] = useUserSessionContext();
  const [win_results, setWinResult] = useState<Record<string, unknown>>({});
  const [error, setError] = useState<unknown>('');
  const [loading, setloading] = useState(false);

  const checkWinResults = useCallback(
    async ({ event_id }: { event_id: string | number }) => {
      const isGuest =
        user && ((user as { guest?: boolean }).guest === true || !(user as { session_id?: string }).session_id || !(user as { player_id?: string }).player_id);
      if (!user || isGuest) return;
      setloading(true);
      setWinResult({});
      RequestClient.get(ENDPOINTS.CHECK_WINS, {
        cancelToken: RequestSource.renewCancelToken(RequestClient, 'check-win-results').token,
        params: { event_id },
      })
        .then((res) => {
          setWinResult((res.data ?? {}) as Record<string, unknown>);
        })
        .catch((err) => {
          setError(err);
          setWinResult({});
        })
        .finally(() => {
          setloading(false);
        });
    },
    [user]
  );

  return {
    win_results,
    error,
    loading,
    setWinResult,
    checkWinResults,
  };
}
